export const DELETED_REF_KEY = '_weave_deleted_ref';

export type DeletedRefValuePlaceholder = {[DELETED_REF_KEY]: string};

type DeletedRefValueRow = {
  value?: Partial<DeletedRefValuePlaceholder>;
};

export const maybeGetDeletedRefValuePlaceholderFromRow = (
  row: DeletedRefValueRow
): string | undefined => {
  return row.value?.[DELETED_REF_KEY];
};
